class Prize {

    constructor(connectionManager, config) {
        this.tradeContainer = null;
        this.locale = config.locale;
        this.ticketLimit = 25000;
    }

    init() {
        this.tradingDrawingId = 0;
        this.tokenPricePerTicket = 0;
        this.currentAmount = 1;
        this.currentOpenTradeContainer = null;
        Array.from(document.querySelectorAll(".drawing-countdown")).forEach(function (drawing) {
            app.prize.initCountdown(drawing);
        });

        this.listenForCloseKey = function (event) {
            if (this.currentOpenTradeContainer) {
                const tradeContainer = document.querySelector('#prize-drawing-' + this.currentOpenTradeContainer.dataset.drawingId + ' .trade-container');
                if (tradeContainer && tradeContainer.classList.contains('hidden')) {
                    document.removeEventListener('keyup', this.listenForCloseKey);
                    return
                }
                let key = event.key || event.keyCode;
                if (key === 'Escape' || key === 'Esc' || key === 27) {
                    app.prize.hideTradeContainer(this.currentOpenTradeContainer);
                }
            }
        }.bind(this);
    }

    tradeDone(response) {
        if (response.success) {
            app.wallet.adjustTokens(response.tokens);
            this.determineWhichSelectorsToShow(response.tokens, response.tickets);
            this.tradeContainer.setAttribute("data-tickets", response.tickets);
            const prizeDrawing = document.querySelector("#prize-drawing-" + response.id + " .prize-drawing");
            if (response.tickets > 0) {
                if (prizeDrawing) {
                    prizeDrawing.classList.add("tickets-owned");
                }
                Array.from(document.querySelectorAll(".bought-tickets-" + response.id)).forEach(function (t) {
                    t.innerHTML = response.tickets;
                });
            } else {
                if (prizeDrawing) {
                    prizeDrawing.classList.remove("tickets-owned");
                }
                Array.from(document.querySelectorAll(".bought-tickets-" + response.id)).forEach(function (t) {
                    t.innerHTML = "0";
                });
            }
            const tokens = document.querySelector('#prize-drawing-' + response.id + ' .total-price .tokens');
            if (tokens) {
                tokens.innerHTML = (response.tickets * this.tokenPricePerTicket).toLocaleString(app.prize.locale);
            }
        } else {
            app.alert.error(response.header, response.message)
        }
    }

    showTradeContainer(element) {
        this.tradingDrawingId = element.dataset.drawingId;
        this.tokenPricePerTicket = element.dataset.tokenPrice;
        this.ticketLimit = element.dataset.ticketsLimit;
        this.tradeContainer = document.querySelector('.trade-container[data-id="' + element.dataset.drawingId + '"]')
        this.amountSelectors = Array.from(this.tradeContainer.querySelectorAll('.amount-select'))
        this.tradeContainer.querySelector('.trade-container-overlay').addEventListener('click', function () {
            app.prize.hideTradeContainer(element)
        }.bind(this))
        this.currentOpenTradeContainer = element;
        document.addEventListener('keyup', this.listenForCloseKey);
        this.tradeContainer.classList.add('showing');
        this.tradeContainer.classList.add('d-block');
        this.determineWhichSelectorsToShow(app.wallet.getTokens());
    }

    hideTradeContainer(element) {
        $(".trade-container").addClass("hiding");
        setTimeout(function () {
            $(".trade-container.hiding").removeClass("hiding showing d-block");
        }, 150);
        document.removeEventListener('keyup', this.listenForCloseKey);
        this.currentOpenTradeContainer = null;
    }

    determineWhichSelectorsToShow(tokens, tickets) {
        if (!this.amountSelectors) {
            return;
        }

        this.maxAmount = Math.min((tokens / this.tokenPricePerTicket), this.ticketLimit);
        this.amountSelectors.forEach(function (t) {
            t.classList.remove('disabled')
            let direction = t.getAttribute('data-direction');
            let amount = parseInt(t.getAttribute('data-amount'));
            if (tickets === undefined) {
                tickets = parseInt(this.tradeContainer.getAttribute('data-tickets'));
            }

            switch (direction) {
                case 'pos':
                    if (tokens < this.tokenPricePerTicket || amount > this.maxAmount || (amount + tickets) > this.ticketLimit || tickets >= this.ticketLimit) {
                        t.classList.add('disabled')
                    }
                    break

                case 'neg':
                    if (amount > tickets || tickets <= 0) {
                        t.classList.add('disabled')
                    }
                    break
            }
        }.bind(this))
    }

    selectAmount(element) {
        if (!element.classList.contains('disabled')) {
            let amount = element.getAttribute('data-amount');
            let direction = element.getAttribute('data-direction');
            if (amount === 'max') {
                switch (direction) {
                    case 'pos':
                        amount = Math.floor(app.wallet.getTokens() / this.tokenPricePerTicket);
                        break

                    case 'neg':
                        amount = this.tradeContainer.getAttribute('data-tickets')
                        break
                }
            }
            app.ajax.post('/services/prize/trade', {
                'id': this.tradingDrawingId,
                'amount': Math.min(this.ticketLimit, amount),
                'direction': direction
            }, this.tradeDone.bind(this), this.tradeDone.bind(this));
        }
    }

    initCountdown(drawing) {
        new Countdown(drawing.id, drawing.getAttribute('data-end-time'),
            () => {
                const drawingContainer = jQuery("#" + drawing.id.replace("-countdown", ""));
                drawingContainer.find(".trade-tickets").fadeOut(200, function () {
                    this.remove();
                });
                drawingContainer.find(".trade-container").fadeOut(200, function () {
                    this.remove();
                });
                drawingContainer.addClass("pulsate-fast");
                app.prize.fetchWinner(drawing.id);
            });
    }

    fetchWinner(id) {
        id = id.replace("prize-drawing-countdown-", "");
        let limit = 10;
        let isFetching = false;
        let checkInterval = setInterval(() => {
            if (!isFetching) {
                isFetching = true;
                app.ajax.get("/services/prize/winner", {id: id}, (data) => {
                    if (data.winner.username) {
                        clearInterval(checkInterval);
                        limit = 0;
                        jQuery("#prize-drawing-" + id).slideUp(200);
                        const first = $("#prize-winners .prize-winner").first();
                        const newWinner = first.clone();
                        const newWinnerWrapper = $("<div></div>");
                        newWinnerWrapper.append(newWinner);
                        const link = newWinner.find("a");
                        link.attr("class", "").addClass(data.winner.userGender);
                        link.attr("href", data.winner.userUrl);
                        link.html(data.winner.username);
                        link.attr("title", data.winner.username);
                        newWinner.find(".drawing-time").html(data.winner.date);
                        newWinner.find(".drawing-text").html(data.winner.title);
                        newWinner.find("img").attr("src", data.winner.imageUrl).attr("title", data.winner.title);
                        newWinnerWrapper.css({height: 0, opacity: 0, animation: "dance 400ms 3"});
                        $("#prize-winners").prepend(newWinnerWrapper);
                        newWinnerWrapper.animate({height: 110, opacity: 1}, 1000);
                    } else {
                        isFetching = false;
                    }
                }, () => {
                    clearInterval(checkInterval);
                });
                if (limit-- <= 0) {
                    clearInterval(checkInterval);
                }
            }
        }, Math.floor(Math.random() * 2500) + 1000)
    }

    unlockHero(id) {
        app.util.setCookie("unlock-hero-" + id, true, 86400);
        $(".unlock-hero[data-id='" + id + "']").fadeOut(200, function () {
            $(this).parent().remove();
        });
    }

    unlockQuiz(id, answer, correct) {
        if (btoa(answer) === correct) {
            app.util.setCookie("uq" + id, btoa(id), 86400);
        } else {
            app.util.setCookie("uq" + id, btoa(id + "true"), 86400);
        }
        $(".unlock-quiz[data-id='" + id + "']").fadeOut(200, function () {
            app.ajax.reload("#prize-drawing-" + id);
            app.ajax.reload("#drawing-" + id);
        });
    }

    participate(id) {
        app.ajax.post('/services/prize/trade', {
            'id': id,
            'amount': 1,
            'direction': "pos"
        }, () => {
            const drawing = $("#drawing-" + id);
            drawing.addClass("tickets-owned");
            drawing.find("button.participate").fadeOut(200, () => {
                drawing.find("button.participating").fadeIn(200);
            });
        }, (e) => {
            if (e.status === "VIP") {
                window.location.href = "/vip";
            }
        });
    }

    openHint(text) {
        app.modal.open("", atob(text), "", "no-padding media");
    }
}
